module.exports = __webpack_public_path__ + "static/TiemposText-Medium-a6932f51dbceb9a02ad9e1c80a9c9dd5.woff2";